import React, { useState } from 'react';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha'; 

import img from '../assets/imgs/contact.webp';
import location from '../assets/imgs/location.webp';
import tele from '../assets/imgs/tele.webp';
import email from '../assets/imgs/email.webp';
import Whatsapp from './Whatsapp';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        project: '',
        budget: ''
    });

    const [captchaToken, setCaptchaToken] = useState(null);
    const [formSubmitted, setFormSubmitted] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setFormSubmitted(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!captchaToken) {
            alert('Please complete the CAPTCHA.');
            return;
        }

        axios.post('https://www.samriddhidevelopers.in/backend/contact_form.php', {
            ...formData,
            captcha: captchaToken
        })
            .then(response => {
                console.log('Form submitted successfully:', response.data);
                setFormSubmitted(true);
                setFormData({ name: '', phone: '', email: '', project: '', budget: '' });
                setCaptchaToken(null); // Reset CAPTCHA

                setTimeout(() => {
                    setFormSubmitted(false);
                }, 3000);
            })
            .catch(error => {
                console.error('There was an error submitting the form!', error);
                setFormSubmitted(false);
            });
    };

    return (
        <>
            <div className="contact-hero">
                <img src={img} loading="lazy" alt="Contact" />
            </div>

            <div className="contact-container">
                <div className="contact-info cmt">
                    <h3>Contact Us</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td><img src={location} loading="lazy" alt="location" /></td>
                                <td>Off.No.407, Navale Icon, Navale Bridge, Wadgaon Budruk, Pune - 411041</td>
                            </tr>
                            <tr>
                                <td><img src={email} loading="lazy" alt="email" /></td>
                                <td>samriddhigroup24@gmail.com</td>
                            </tr>
                            <tr>
                                <td><img src={tele} loading="lazy" alt="tele" /></td>
                                <td>+91 97300 20099 / 97300 50099</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="contact-form cmt">
                    <h3>Get in Touch</h3>
                    <p>Please fill out the form below</p>
                    <form onSubmit={handleSubmit}>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Your Name"
                            required
                        />
                        <input
                            type="phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="Your Phone Number"
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Your Email"
                            required
                        />
                        <select
                            name="project"
                            id='contact-project-of-interest'
                            value={formData.project}
                            onChange={handleChange}
                            required
                        >
                            <option value="">-- Select Project of Interest --</option>
                            <option value="waterscape">Waterscape - panshet,pune</option>
                            <option value="lonavalley">Lonavalley - @Lonavala Annexe</option>
                            <option value="blue_horizon">Blue Horizon - @Hinjewadi Annexe</option>
                            <option value="swaraj_toran">Swaraj Toran - Velha</option>
                            <option value="bhor">Bhor</option>
                            <option value="mahabaleshwar">Forest Hills - @Mahabaleshwar</option>
                        </select>
                        <input
                            type="text"
                            name="budget"
                            value={formData.budget}
                            onChange={handleChange}
                            placeholder="Max Budget"
                            required
                        />

                        {/* ✅ reCAPTCHA */}
                        <ReCAPTCHA
                            sitekey="6LeFlmArAAAAAG3OpN5TM6JZ6ZBq1p_mKUTCn85-"
                            onChange={(token) => setCaptchaToken(token)}
                        />

                        <button type="submit">SEND</button>

                        {formSubmitted && (
                            <p className="c-success-message">Form submitted successfully!</p>
                        )}
                    </form>
                </div>
            </div>

            <Whatsapp />
        </>
    );
};

export default Contact;
